define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "mojo/page/request"], function (declare, request) {
  return declare([], {
    constructor: function (params) {
      document.addEventListener('click', function (e) {
        if (e.target.tagName !== 'A') {
          return;
        }
        request.get(params.endpoint + "&url=" + encodeURIComponent(e.target.href));
      }, false);
    }
  });
});